var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65247 16.061H7.87902V49.9996H6.65247V16.061Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71985 18.9785H10.9464V50.0003H9.71985V18.9785Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7863 22.6094H14.0128V50H12.7863V22.6094Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8527 25.1338H17.0792V49.9924H15.8527V25.1338Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9191 27.5923H20.1456V49.9921H18.9191V27.5923Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9865 25.1338H23.213V49.9924H21.9865V25.1338Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0529 22.2646H26.2794V49.992H25.0529V22.2646Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1193 20.2402H29.3458V49.9915H28.1193V20.2402Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1866 19.4219H32.4132V49.9929H31.1866V19.4219Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2521 22.2646H35.4785V49.992H34.2521V22.2646Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3195 25.1338H38.546V49.9924H37.3195V25.1338Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3849 28.4121H41.6115V49.9924H40.3849V28.4121Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4523 31.2969H44.6787V49.9911H43.4523V31.2969Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5197 33.9609H47.7463V50.0002H46.5197V33.9609Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5851 38.7964H50.8116V50H49.5851V38.7964Z",
    fill: "black",
    fillOpacity: 0.24
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51134 12.9703L18.778 25.7558H18.8332C18.9115 25.829 18.9957 25.8896 19.0847 25.9365L19.1827 25.9857C19.2939 26.032 19.4099 26.0566 19.5262 26.0594C19.6298 26.0577 19.7329 26.0383 19.833 26.0023L19.925 25.9611C20.0016 25.9245 20.0756 25.8776 20.1457 25.8216H20.2009L31.1609 16.0437L49.5237 33.3781L48.0884 36.5665L56.0001 36.7466L52.1672 27.5096L50.7935 30.5666L31.9401 12.774C31.4763 12.3978 30.8949 12.3978 30.4312 12.774L19.6123 22.4861L8.02037 10.3888C7.76539 10.1007 7.43382 9.96288 7.10183 10.0086C6.7694 10.0544 6.46565 10.279 6.2603 10.6306C6.05451 10.9822 5.9651 11.4304 6.01259 11.8724C6.06007 12.3137 6.24019 12.7105 6.51143 12.9706L6.51134 12.9703Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/Payments.57a9537cd10891626b3f487dcdfe6bc0.svg";
export { ForwardRef as ReactComponent };